import { Directive, ElementRef, TemplateRef, input, signal, HostBinding, inject } from '@angular/core';
import { Highlightable } from '@angular/cdk/a11y';

@Directive({
  selector: 'ng-template[bsTemplate]',
  standalone: true
})
export class BsListboxTemplateDirective {
  readonly type = input<string>('', { alias: 'bsTemplate' });

  constructor(public templateRef: TemplateRef<unknown>) {}
}

@Directive({
  selector: '[bsListboxOption]',
  standalone: true
})
export class BsListboxOptionDirective implements Highlightable {
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly active = signal(false);

  readonly label = input('');
  readonly disabledState = input(false);

  @HostBinding('class.is-focused')
  get focusClass(): boolean {
    return this.active();
  }

  @HostBinding('attr.tabindex')
  get tabindex(): number {
    return -1;
  }

  @HostBinding('attr.aria-disabled')
  get ariaDisabled(): boolean {
    return this.disabledState();
  }

  get disabled(): boolean {
    return this.disabledState();
  }

  get elementId(): string | null {
    return this.elementRef.nativeElement.id || null;
  }

  getLabel(): string {
    return this.label();
  }

  setActiveStyles(): void {
    this.active.set(true);
  }

  setInactiveStyles(): void {
    this.active.set(false);
  }

  focus(): void {
    this.elementRef.nativeElement.focus();
  }
}
